const KEY = 'androidApp';

function detect() {
  try {
    const fromTwa = document.referrer.startsWith('android-app://')
      || new URLSearchParams(window.location.search).get('source') === 'twa';
    if (fromTwa) sessionStorage.setItem(KEY, '1');
    return sessionStorage.getItem(KEY) === '1';
  } catch (_) {
    return false;
  }
}

// True inside the Google Play (TWA) build; store billing rules apply there.
export const IS_ANDROID_APP = detect();
